(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["look-inside"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.look').forEach(function (root) {
    var track = root.querySelector('[data-look-track]');
    if (!track) return;
    var step = function (dir) {
      var slide = track.querySelector('.look__slide');
      var amount = slide ? slide.getBoundingClientRect().width + 20 : 300;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: dir * amount, behavior: reduce ? 'auto' : 'smooth' });
    };
    root.querySelector('[data-look-prev]').addEventListener('click', function () { step(-1); });
    root.querySelector('[data-look-next]').addEventListener('click', function () { step(1); });
  });

  } catch(e) { console.error(e); }
})();
})();
